module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 005.acef1c8c.jpg";